<template>
  <div class="card-body p-xl-40">
    <h6 class="fs-18 mb-35 text-title fw-semibold">Ventas Recientes</h6>
    <div class="table-responsive style-one">
      <table class="table text-nowrap align-middle mb-0">
        <thead>
          <tr>
            <th class="text-title fw-normal fs-14 pt-0 ps-0">COMPROBANTE</th>
            <th class="text-title fw-normal fs-14 pt-0">FECHA</th>
            <th class="text-title fw-normal fs-14 pt-0">SEDE</th>
            <th class="text-title fw-normal fs-14 pt-0">VENDEDOR</th>
            <th class="text-title fw-normal fs-14 pt-0">ÍTEMS</th>
            <th class="text-title fw-normal fs-14 pt-0 pe-0 text-end">TOTAL</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="loading">
            <tr v-for="n in 6" :key="n">
              <td colspan="6"><div class="placeholder-glow"><span class="placeholder col-12 rounded-1" style="height:18px"></span></div></td>
            </tr>
          </template>
          <tr v-else-if="!ventas.length">
            <td colspan="6" class="text-center text-muted py-4 fs-14">Sin ventas recientes</td>
          </tr>
          <tr v-else v-for="v in ventas" :key="v.comprobante">
            <td class="shadow-none fs-14 fw-semibold text-purple ps-0">{{ v.comprobante }}</td>
            <td class="shadow-none fs-14 fw-normal text-paragraph">{{ formatFecha(v.fecha) }}</td>
            <td class="shadow-none fs-14 fw-normal text-paragraph">{{ v.almacen || '—' }}</td>
            <td class="shadow-none fs-14 fw-normal text-paragraph">
              <span v-if="v.vendedor" class="vendedor-chip">{{ v.vendedor }}</span>
              <span v-else class="text-muted">—</span>
            </td>
            <td class="shadow-none fs-14 fw-normal text-paragraph">{{ v.items }}</td>
            <td class="shadow-none fs-14 fw-semibold text-paragraph text-end pe-0">S/ {{ Number(v.total).toFixed(2) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import api from '../../services/api';

export default {
  name: 'RecentSales',
  data() { return { ventas: [], loading: true }; },
  async mounted() {
    try {
      const res = await api.get('/dashboard');
      this.ventas = res.data.data.ventasRecientes || [];
    } catch (e) {
      console.error('RecentSales', e);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    formatFecha(f) {
      if (!f) return '—';
      const s = String(f).substring(0, 10); return new Date(s + 'T00:00:00').toLocaleDateString('es-PE', { day: '2-digit', month: '2-digit', year: 'numeric' });
    },
  },
};
</script>

<style scoped>
.vendedor-chip {
  display: inline-block;
  padding: 2px 8px;
  background: #eff6ff;
  color: #2563eb;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 500;
}
</style>
